﻿import styles from "./MatchingSuccess.module.css";

export default function MatchingSuccess() {
  return (
    <div className={styles.container} aria-hidden>
      <div className={styles.ok}>
        <svg className={styles.icon} viewBox="0 0 24 24">
          {/* two nodes that slide in from each side */}
          <circle className={`${styles.node} ${styles.nodeLeft}`} cx="6" cy="12" r="2.4" />
          <circle className={`${styles.node} ${styles.nodeRight}`} cx="18" cy="12" r="2.4" />
          {/* connecting link drawn between them once they meet */}
          <path className={styles.link} d="M8.4 12h7.2" />
        </svg>
      </div>
    </div>
  );
}
